module.exports = __webpack_public_path__ + "static/media/fire.ba477ba8.gif";